import { createContext } from "react";

export interface IMenuTreeContext {
  /** 选中的菜单节点 */
  selectedKey?: string;
  /** 选中的分组节点 */
  selectedSubMenuKey?: string;
  /** 是否开启动画，只有二级菜单有效 */
  animation?: boolean;
  /** 分组节点是否可以选中 */
  isSelectSubMenu?: boolean;
  /** 选中菜单 */
  onSelect?: (value: string, label: any, parentKey?: string) => void;
  /** 打开、关闭分组 */
  onOpen?: (isOpen: boolean, value: string, label: any) => void;
  /** 展开分组 */
  openSubMenus?: string[];
}

const MenuTreeContext = createContext<IMenuTreeContext>({});

export default MenuTreeContext;